import { Typography, Grow } from '@material-ui/core';
import React, { useContext } from 'react';
import { useStyles } from './useStyles';
import { LanguageContext } from '../../App'

export const Title = (props) => {
	const classes = useStyles();
	const { language } = useContext(LanguageContext);
	return (
		<div className={classes.title}>
			<Grow in={true} timeout={1000}>
				<Typography variant="h4" color="secondary" >
					{language === 'spanish' ? 'BIENVENIDE A MI PORTFOLIO' : 'WELCOME TO MY PORTFOLIO'}
				</Typography>
			</Grow>
		</div>
	);
};
